// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview--B3VIM","preview__table":"preview__table--oecto"};